var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white border border-ag-grey p-4 \n        sm:px-10 sm:mx-auto sm:w-full sm:max-w-md md:rounded-md md:py-8",attrs:{"data-component":"form-wrap"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }